const env = process.env.NODE_ENV || 'development'
let domain = window.location.hostname

if (env === 'development') {
    domain = 'tazztv.me'
}

export const API_URL = `https://${domain}/`
